import React, {useContext} from 'react';
import {ViewContext} from './contexts/ViewContext';
import {makeStyles} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import {Divider} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	m2: {
		margin: 16,
	},
	ml3: {
		marginLeft: 16,
	},
}));

const doSomething = () => {};

export default function SideMenu() {
	const {view, dispatch} = useContext(ViewContext);
	const classes = useStyles();

	return (
		<div className="sidemenu" role="presentation">
			<Typography className={classes.m2} variant="h5" component="h2">
				Map Views
			</Typography>
			<List>
				<ListItem
					button
					selected={view.mapView == 'props'}
					key="props"
					onClick={() => dispatch({type: 'CHANGE VIEW', mapView: 'props'})}
				>
					<ListItemText className={classes.ml3} primary="Sidewalk properties" />
				</ListItem>
				<ListItem
					button
					selected={view.mapView == 'routes'}
					key="routes"
					onClick={() => dispatch({type: 'CHANGE VIEW', mapView: 'routes'})}
				>
					<ListItemText className={classes.ml3} primary="Routes and detours" />
				</ListItem>
				<ListItem
					button
					selected={view.mapView == 'indices'}
					key="indices"
					onClick={() => dispatch({type: 'CHANGE VIEW', mapView: 'indices'})}
				>
					<ListItemText className={classes.ml3} primary="Accessibility indices" />
				</ListItem>
			</List>
			<Divider />
			{view.mapView != 'routes' && (
				<Typography className={classes.m2} variant="overline">
					Filters
				</Typography>
			)}

			{view.mapView == 'props' && (
				<React.Fragment>
					<List>
						<ListItem
							button
							selected={view.mapFilterProps == 'roughness'}
							key="roughness"
							onClick={() => dispatch({type: 'CHANGE VIEW', mapFilterProps: 'roughness'})}
						>
							<ListItemText className={classes.ml3} secondary="Roughness" />
						</ListItem>
						<ListItem
							button
							selected={view.mapFilterProps == 'curbs'}
							key="curbs"
							onClick={() => dispatch({type: 'CHANGE VIEW', mapFilterProps: 'curbs'})}
						>
							<ListItemText className={classes.ml3} secondary="Curb heights" />
						</ListItem>
						<ListItem
							button
							selected={view.mapFilterProps == 'incline'}
							key="incline"
							onClick={() => dispatch({type: 'CHANGE VIEW', mapFilterProps: 'incline'})}
						>
							<ListItemText className={classes.ml3} secondary="Incline" />
						</ListItem>
						<ListItem
							button
							selected={view.mapFilterProps == 'width'}
							key="width"
							onClick={() => dispatch({type: 'CHANGE VIEW', mapFilterProps: 'width'})}
						>
							<ListItemText className={classes.ml3} secondary="Width" />
						</ListItem>
						<ListItem
							button
							selected={view.mapFilterProps == 'paving'}
							key="paving"
							onClick={() => dispatch({type: 'CHANGE VIEW', mapFilterProps: 'paving'})}
						>
							<ListItemText className={classes.ml3} secondary="Paving material" />
						</ListItem>
						<ListItem
							button
							selected={view.mapFilterProps == 'obstacles'}
							key="obstacles"
							onClick={() => dispatch({type: 'CHANGE VIEW', mapFilterProps: 'obstacles'})}
						>
							<ListItemText className={classes.ml3} secondary="Reported obstacles" />
						</ListItem>
					</List>
				</React.Fragment>
			)}
			{view.mapView == 'routes' && (
				<React.Fragment>
					<List></List>
				</React.Fragment>
			)}
			{view.mapView == 'indices' && (
				<React.Fragment>
					<List>
						<ListItem
							button
							selected={view.mapFilterIndices == 'walkability'}
							key="walkability"
							onClick={() => dispatch({type: 'CHANGE VIEW', mapFilterIndices: 'walkability'})}
						>
							<ListItemText className={classes.ml3} secondary="Walkability" />
						</ListItem>
						<ListItem
							button
							selected={view.mapFilterIndices == 'rollability'}
							key="rollability"
							onClick={() => dispatch({type: 'CHANGE VIEW', mapFilterIndices: 'rollability'})}
						>
							<ListItemText className={classes.ml3} secondary="Rollability" />
						</ListItem>
						<ListItem
							button
							selected={view.mapFilterIndices == 'inclusion'}
							key="inclusion"
							onClick={() => dispatch({type: 'CHANGE VIEW', mapFilterIndices: 'inclusion'})}
						>
							<ListItemText className={classes.ml3} secondary="Inclusion index" />
						</ListItem>
					</List>
				</React.Fragment>
			)}
		</div>
	);
}
